export const MainPageRoute = String('/')
export const LandingPageRoute = MainPageRoute
export const InvitationByEmailPageRoute = String(':code/:token')
export const InvitationByEmailInfoPageRoute = String('info-email')
export const InvitationByMailRoute = String('mail')
export const DownloadAppRoute = String('download-app')
export const ErrorRoute = String('error')

export const SendNewInvitationRoute = String('/new-invitation')
export const InvitationExpiredRoute = String('/invitation-expired')
